import { Check, Clock } from 'lucide-react';
import type { OnboardingSupportMailStatus } from '@/shared/api';
import { formatDateTime } from '@/shared/lib/format';

/** Begrüßung und Erinnerungen mit Versandzeit; „noch nicht“ statt eines behaupteten Plans. */
export function OnboardingMailSteps({ link }: { link: OnboardingSupportMailStatus }) {
  const steps: Array<{ label: string; at: string | null | undefined }> = [
    { label: 'Begrüßung', at: link.welcomeSentAt },
    { label: 'Erinnerung · 5 Tage vorher', at: link.reminder5dSentAt },
    { label: 'Erinnerung · 1 Tag vorher', at: link.reminder1dSentAt },
  ];
  return (
    <ul className="space-y-2">
      {steps.map((step) => (
        <li key={step.label} className="flex items-center justify-between gap-3 text-sm">
          <span className="flex items-center gap-2">
            {step.at ? (
              <Check size={14} strokeWidth={2.5} aria-hidden className="text-forest" />
            ) : (
              <Clock size={14} strokeWidth={2} aria-hidden className="text-ink-soft" />
            )}
            {step.label}
          </span>
          <span className="text-ink-soft font-mono text-xs">
            {step.at ? formatDateTime(step.at) : 'noch nicht'}
          </span>
        </li>
      ))}
    </ul>
  );
}

/** Ablauf und Nutzung des Links. */
export function OnboardingLinkUsage({ link }: { link: OnboardingSupportMailStatus }) {
  return (
    <p className="text-ink-soft mt-3 text-xs">
      {link.expiresAt
        ? new Date(link.expiresAt).getTime() < Date.now()
          ? `Abgelaufen am ${formatDateTime(link.expiresAt)}`
          : `Gültig bis ${formatDateTime(link.expiresAt)}`
        : 'Keine Ablaufzeit hinterlegt'}
      {link.useCount > 0 ? (
        <> · vom Gast bereits geöffnet ({link.useCount}×)</>
      ) : (
        <> · noch nicht geöffnet</>
      )}
    </p>
  );
}
